function arrowRightLong({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M29.3605 13.0607C29.9463 12.4749 29.9463 11.5251 29.3605 10.9393L19.8145 1.3934C19.2287 0.807613 18.279 0.807613 17.6932 1.3934C17.1074 1.97919 17.1074 2.92893 17.6932 3.51472L26.1785 12L17.6932 20.4853C17.1074 21.0711 17.1074 22.0208 17.6932 22.6066C18.279 23.1924 19.2287 23.1924 19.8145 22.6066L29.3605 13.0607ZM0.299805 13.5L28.2998 13.5L28.2998 10.5L0.299805 10.5L0.299805 13.5Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default arrowRightLong;
